import makeCrud from '@/store/site/localization/crud'

// Özel alanlar (attribute) — ad çeviri tablosuna gider; language_id payload ile gönderilir.
export default makeCrud('ecommerce_product_attribute')
